export const calendarI18n = {
  en: {
    data: {
      event: 'Event',
      task: 'Task',
      description: 'Description',
      summary: 'Summary',
      location: 'Location',
      categories: 'Categories',
      attendees: 'Attendees',
      percentage: 'Complete Percentage',
      frequency: 'Frequency',
      status: 'Status',
      calendar: 'Calendar',
      startDate: 'Initial date',
      endDate: 'Final date',
      year: 'Year',
      weekly: 'Week',
      monthly: 'Month',
      week: 'Week',
      month: 'Month',
      day: 'Day',
      goToday: 'Today',
      personal: 'Personal',
      courses: 'Subject',
      organization: 'Organization',
      remove: 'Remove',
      LoadingCalendar: 'Loading Calendar',
      errorLoadingCalendar: 'There was an error on loading calendar',
      successChanges: 'The changes were saved succesfully',
      unSuccesChanges: 'There was an error saving your changes.',
      createEvents: 'You can\'t create events in the past.',
      every: 'Every',
      weekday: 'Weekdays',
      until: 'Until date',
      endRepeat: 'End Repeat',
      times: 'Times',
      freqOn: 'On',
      position: 'Position',
      weekd: 'Weekday',
      required: 'Required',
      daysInMonth: 'Days (Month)',
      eventRemoved: 'The event {eventName} was removed succesfully',
      eventCreated: 'The event {eventName} was created succesfully',
      eventUpdated: 'The event {eventName} was updated succesfully',
      fieldRequired: 'This field is required.',
      fieldLimit: 'Name must be less than {amount} characters.',
      dateErrorLimit: 'The final date must be greater than the start date.',
      dateErrorNoPast: 'The start date cannot be less than current date.',
      dateErrorNoPastEnd: 'The end date cannot be less than the current date.',
      everyDay: ' (Days)',
      everyWeek: ' (Weeks)',
      everyMonth: ' (Months)',
      everyYear: ' (Years)',
      expandCalendar: 'Expand Calendar',
      contractCalendar: 'Contract Calendar',
      categoriesMax: 'Maximum {max} categories',
      itemAdd: 'No results matching. Press enter to create a new one.',
      attendeesFormat: 'Attendees are email addresses (Ex: user@eduac.com)',
      selectCalendar: 'Select calendar',
      errorLoadingEvents: 'There was a problem loading the calendar events.',
      myCalendar: 'My Calendar'
    },
    repeat: {
      never: 'Never',
      after: 'After',
      onDate: 'On Date'
    },
    frequency: {
      notSelected: '',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
    status: {
      tentative: 'Tentative',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      completed: 'Completed',
      inProcess: 'In Proccess',
      needsAction: 'Needs Action',
    },
    week: {
      su: 'Sunday',
      mo: 'Monday',
      tu: 'Tuesday',
      we: 'Wednesday',
      th: 'Thursday',
      fr: 'Friday',
      sa: 'Saturday',
      dm: 'Day of the Month'
    },
    month:{
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      may: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December'
    },
    posday: {
      '1': 'First',
      '2': 'Second',
      '3': 'Third',
      '4': 'Fourth',
      '5': 'Fift',
      '-1': 'Last'
    }
  },
  es: {
    data: {
      event: 'Evento',
      task: 'Tarea',
      description: 'Descripción',
      summary: 'Resumen',
      location: 'Localización',
      categories: 'Categorias',
      attendees: 'Asistentes',
      percentage: 'Porcentaje Completado',
      frequency: 'Frecuencia',
      status: 'Estado',
      calendar: 'Calendario',
      startDate: 'Fecha Inicial',
      endDate: 'Fecha Final',
      year: 'Año',
      weekly: 'Semana',
      monthly: 'Mes',
      week: 'Semanal',
      month: 'Mensual',
      day: 'Día',
      goToday: 'Hoy',
      personal: 'Personal',
      courses: 'Curso',
      organization: 'Organización',
      remove: 'Borrar',
      LoadingCalendar: 'Cargando Calendario',
      errorLoadingCalendar: 'Se produjo un error al cargar el calendario',
      successChanges: 'Los cambios se guardarón correctamente',
      unSuccesChanges: 'Se produjo un error al guardar los cambios',
      createEvents: 'No puedes crear eventos en días pasados',
      every: 'Cada',
      weekday: 'Días Laborales',
      until: 'Hasta la fecha',
      endRepeat: 'Finalizar repetición',
      times: 'Veces',
      freqOn: 'Sobre',
      position: 'Posición',
      weekd: 'Dia de la semana',
      required: 'Requerido',
      daysInMonth: 'Días (Mes)',
      eventRemoved: 'El evento {eventName} fue eliminado correctamente.',
      eventCreated: 'El evento {eventName} fue creado correctamente.',
      eventUpdated: 'El evento {eventName} fue actualizado correctamente.',
      fieldRequired: 'Esta campo es requerido.',
      fieldLimit: 'El campo debe tener menos de {amount} caracteres',
      dateErrorLimit: 'La fecha final debe ser mayor que la fecha inicial.',
      dateErrorNoPast: 'La fecha inicial no puede ser menor que la fecha actual.',
      dateErrorNoPastEnd: 'La fecha final no puede ser inferior a la fecha actual.',
      everyDay: ' (Dias)',
      everyWeek: ' (Semanas)',
      everyMonth: ' (Meses)',
      everyYear: ' (Años)',
      expandCalendar: 'Expandir Calendario',
      contractCalendar: 'Contraer Calendario',
      categoriesMax: 'Máximo {max} categorías',
      itemAdd: 'No hay resultados coincidentes. Presiona enter para crear uno nuevo.',
      attendeesFormat: 'Los invitados son direcciones de correo (Ej: user@eduac.com)',
      selectCalendar: 'Seleccione el calendar',
      errorLoadingEvents: 'Hubo un problema cargando los eventos del calendario.',
      myCalendar: 'Mi Calendario'
    },
    repeat: {
      never: 'Nunca',
      after: 'Depues',
      onDate: 'Hasta la fecha'
    },
    frequency: {
      notSelected: '',
      daily: 'Diario',
      weekly: 'Semanal',
      monthly: 'Mensual',
      yearly: 'Anual'
    },
    status: {
      tentative: 'Tentativo',
      confirmed: 'Confirmado',
      cancelled: 'Cancelado',
      completed: 'Completado',
      inProcess: 'En proceso',
      needsAction: 'Requiere acción',
    },
    week: {
      su: 'Domingo',
      mo: 'Lunes',
      tu: 'Martes',
      we: 'Miercoles',
      th: 'Jueves',
      fr: 'Viernes',
      sa: 'Sabado',
      dm: 'Día del mes'
    },
    month:{
      jan: 'Enero',
      feb: 'Febrero',
      mar: 'Marzo',
      apr: 'Abril',
      may: 'Mayo',
      jun: 'Junio',
      jul: 'Julio',
      aug: 'Agosto',
      sep: 'Septiembre',
      oct: 'Octubre',
      nov: 'Noviembre',
      dec: 'Diciembre'
    },
    posday: {
      '1': 'Primero',
      '2': 'Segundo',
      '3': 'Tercero',
      '4': 'Cuarto',
      '5': 'Quinto',
      '6': 'Último'
    }
  }
}
